import importerSelectors from '../../../modules/shared/importer/importerSelectors'

const operationImporterSelectors = importerSelectors(
  'operation.importer',
)

export default operationImporterSelectors
